import { Link } from 'react-router-dom';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function SweepFormatter({ info, sweeps }) {
  const { row: { sweepId } } = getInfo(info)
  const { id, title } = sweeps.find(sweep => sweep.id === sweepId) || {}

  if (!id) {
    return '--'
  }

  return <>
    <Link to={`/cms/sweep/${id}`} className="twy-text-base-accent hover:underline" >
      {`[#${id}] - ${title}`}
    </Link>
  </>
}
